<div class="PGSlugEditor">
    @if(elementData && elementURL) {
        <div class="d-flex align-items-center">
            <b class="me-2">URL</b>
            @if (!elementData.published) {
                <span>{{elementURL}}</span>
            }
            @else {
                <a target="_blank" href="{{elementURL}}">{{elementURL}}</a>
            }
            @if (hasSlug() && !readonly) {
                <button class="btn btn-sm btn-link" (click)="openEditModal()">
                    <i class="fa-regular fa-edit"></i>
                </button>
            }
        </div>
        @if (elementData.published) {
            @if(hasURLQR) {
                <div>
                    <button class="btn btn-link p-0" (click)="viewElementURLQR()">
                        <i class="fa-regular fa-qrcode"></i><span>{{ 'pg-slug-editor.view-url-qr' | locTranslate }}</span>
                    </button>
                </div>
            }
        }
        @else {
            <span class="text-muted">
                <i class="fa-regular fa-eye-slash me-2"></i><span>{{ 'pg-slug-editor.not-published' | locTranslate }}</span>
            </span>
        }
        
        <div class="d-none" #elementURLQRCode>
            <app-pg-qrcode [text]="elementURL"></app-pg-qrcode>
        </div>
    }
</div>

<ng-template #editModal>
    @if(editModalSaving) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-slug-editor.modal-title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="editModalDismiss()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group m-0">
            <div class="d-flex justify-content-between">
                <label>
                    <b>{{ 'pg-slug-editor.field-label' | locTranslate }}</b>
                </label>
            </div>
            <input class="form-control {{ isEditModalValueValid() ? '' : 'ng-invalid' }}" [(ngModel)]="editModalValue"/>
            <div class="form-text">{{ 'pg-slug-editor.field-tooltip' | locTranslate }}</div>
        </div>
        @if(editModalSaveError) {
            <div class="text-danger mt-2">
                <i class="fa-regular fa-circle-exclamation me-2"></i>
                <span>{{ 'pg-slug-editor.modal-save-error' | locTranslate }}</span>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" [disabled]="editModalSaving" (click)="editModalDismiss()">
            <i class="fa-regular fa-undo"></i><span>{{ 'pg-slug-editor.modal-button-cancel' | locTranslate }}</span>
        </button>
        <button class="btn btn-primary" [disabled]="!editModalCanSave()" (click)="editModalDoSave()">
            <i class="fa-regular fa-save"></i><span>{{ 'pg-slug-editor.modal-button-save' | locTranslate }}</span>
        </button>
    </div>
</ng-template>
